import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>Medical necessity cannot be verified through this system for this member. Please submit a paper prior approval documenting medical necessity.</p>

				<p>For instructions on how to begin a paper Prior Approval request, click Continue. </p>
						
				<div className="button" onClick={()=>this.props.navigate('R13A' )}>Continue</div>
			</div>
		);
	}
}